import Link from 'next/link';
import Head from 'next/head';

import {WEBSERVER, APISERVER, numberToCurrency, imgpath} from "../../services/globals"
import Popup from 'reactjs-popup';
import { GetStaticProps } from "next";
import { ApolloClient, InMemoryCache, gql, useMutation } from "@apollo/client";
import { ParsedUrlQuery } from "querystring";
import {IActiveOrder, ICart, ProductItem, IArticle, ProductVariant2, Product_list_elem, IFacetValues} from "../../components/contracts/types";
import Soffer from '../../components/soffer'
import {useRouter} from 'next/router';
import PlaceCartComponent from '../../components/placecart'
import ProductCard from '../../components/ProductCard'
import { Queries } from "../../services/queries";
import {Collection, CategoriesData } from "../../components/contracts/types";

import React, { useState, useEffect } from "react";
import User from "../../components/user";
import Header2 from '../../components/header-2';
import MenuComponent from "../../components/header";
//import { AppPageRouteModule } from 'next/dist/server/future/route-modules/app-page/module.compiled';

interface IParams extends ParsedUrlQuery {
  slug: string;
}


export default function categorypage({categories,items,slugy}) {
    //console.log("+++++++++++++++++++Items" +JSON.stringify(items.data.collection.productVariant));
    console.log("+++++++++++++++++++Data",categories);

    const pageTitle = items?.data?.collection?.name
      ? items.data.collection.name
      : typeof slugy === 'string' && slugy.length > 0
        ? slugy
        : 'Kategorie';

     let list = [];
     let sitem : ProductVariant2;
     let facet : IFacetValues;
     let lastid = 0;
     let vcount:number = 0;
     let lastprice : number = Number.MAX_SAFE_INTEGER; //High number

    let path = `<a href="${WEBSERVER}">Home</a>/`;
    let link = WEBSERVER + "/category/" + items.data.collection.parent.slug;

    if (items.data.collection.parent.name != "__root_collection__") {
      path += '<a href="' + link + '">' + items.data.collection.parent.name  + "</a>/";
    }
    link = WEBSERVER + "/category/" + items.data.collection.slug;
    if (items.data.collection.name) {
      path += '<a href="' + link + '">' + items.data.collection.name  + "</a>";
    }

        //console.log("\n+++++++++ "  +JSON.stringify(items.data.collection));
        let article:IArticle = {
          hid :"",
          id :"",
          hname  :"",
          name  :"",
          slug :"",
          hdescription : "",
          description :"",
          img :"",
          price :"",
          soffer :false,
          vcount : 1,
        };

      
        let lastarticle: IArticle;

        for (sitem of items.data.collection.productVariants.items) {
                 
          
          lastarticle = JSON.parse(JSON.stringify(article));

          ++vcount;

          let hid = parseInt(sitem.product.id);
          if (!lastid) {lastid = hid}
          if (hid != lastid) {
            lastarticle.vcount = vcount - 2 ;
            vcount = 1;
            lastprice =  Number.MAX_SAFE_INTEGER;

          }
          article.id = sitem.id;
          article.hname = sitem.product.name;
          article.hid = sitem.product.id;
          article.hdescription = sitem.product.description;
          article.img = imgpath(sitem.product.assets[0].source);
          article.slug = sitem.product.slug;
          article.soffer = false;

          const hasFacetId41 = (sitem.product.facetValues ?? []).some((facetValue: any) => {
            const facetId = Number(facetValue?.id);
            return facetId === 41 || facetId === 40;
          });

          if (hasFacetId41) {
            article.soffer = true;
          }
          article.vcount = vcount - 2 ;

          //console.log("facetValues: " + JSON.stringify(article.facetValues));
          //console.log("\n++++" + article.hname + "+++++" + id + " " + lastid + " vcount " + vcount +  "\n"); // +JSON.stringify(sitem));

          let price : number  = sitem.priceWithTax;

          if (price < lastprice) {
            lastprice = price;
          }

          let ab : string = "ab ";
          if (vcount < 2) {
              ab ="  ";
          }
          //console.log("\n++++" + hid + " " + lastid + " vcount " + vcount);
          article.price = ab + numberToCurrency(lastprice);
          //lastarticle.price = article.price;

          if (hid != lastid) {
            //console.log("\n--wechsel id---" + id + " " + lastid + " vcount " + vcount); //\n" +JSON.stringify(lastarticle));
            lastid=hid;
            list.push(lastarticle);
            
          } 
     } 
     ++article.vcount;
     list.push(article);
      // console.log("\n--ende id: " + JSON.stringify(article));
      //     list.push(article); //letzter Artikel

    function detailurl(slug:String) {
      return WEBSERVER + "/items/" + slug;
    }
return (
  <div>
    <Head>
      <title>{pageTitle}</title>
      <meta name="description" content={`Schnäppchen finden lohnt sich für ${pageTitle}`} />
      <link rel="canonical" href={link} />
    </Head>
    <Header2 collections={categories.collections}></Header2>

    <div className="container-fluid">
      <div className="breadcrums">{<div dangerouslySetInnerHTML={{__html: path}} />}</div>
      <div className="row row-cols-1 row-cols-md-3 g-4">
        {list.map((elem) => (
          <div key={elem.id} className='product-outer col-md-4'>
            <ProductCard
              article={elem}
              actions={
                <div className="d-flex flex-row justify-content-between margin-buy-box mt-auto">
                  <div><a className="btn btn-info" href={detailurl(elem.slug)}>Details</a></div>
                  {elem.vcount ? <div></div> :
                    <div><PlaceCartComponent idnr={elem.id} qty="1" select={null}></PlaceCartComponent></div>
                  }
                </div>
              }
            />
          </div>
        ))}
      </div>
    </div>
  </div>
);
}


export async function getStaticPaths() {

    const queries = new Queries(null);
    const categories = await queries.getCategories() as CategoriesData; 

    const paths = categories.collections.items.map((item) => ({
      params: { category: item.slug },
    }))

    console.log("path:" +JSON.stringify(paths))
  
     return { paths, fallback: false };
  }

   export const getStaticProps: GetStaticProps = async (context): Promise<any> => {
  
    const slugy  = context.params.category;

    const slug = slugy.toString(); //"electronics";
    
    const queries = new Queries(null);
    const items = await queries.getItemsFromPage(slug);

    //console.log("+++++++++++++++++++slugy" + slugy + JSON.stringify(items));
   
    const categories = await queries.getCategories();
    //console.log("~~~~~~~~~~~~~~~~~" + JSON.stringify(categories))
    
    return {
        props: {
            items,categories,slugy
          },
    };
  
  };
  
